export default __webpack_public_path__ + "static/media/app-stripe.38ac6d9a.jpg";